import { Pipe, PipeTransform } from '@angular/core';

import { getUaDevice } from '../utils';

@Pipe({
	name: 'getDevice',
	standalone: true,
})
export class GetDevicePipe implements PipeTransform {
	/**
	 * Called to just get the current device easily. No value is needed.
	 * @param _empty provide an empty value
	 */
	transform(_empty: null | undefined) {
		return getUaDevice();
	}
}
